import { environment } from '@environments/environment';

export const cognitoRedirectUrl = `${environment.DOMAIN}/oauth2/authorize?response_type=code&client_id=${environment.CLIENT_ID}&redirect_uri=${environment.REDIRECT_URI}&identity_provider=${environment.COGNITO_IDENTITY_PROVIDER}&scope=openid+email&prompt=none`;
